export default "__VITE_ASSET__BRg3qgKN__"